import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'components/cards/card';
import { CardThemeType } from 'components/cards/card-type';
import { WaitingLoader } from 'components/loaders/waiting-loader/waiting-loader';
import { Panel } from 'components/panels/panel';
import { PanelThemeType, PanelType } from 'components/panels/panel-type';
import { AppContext } from 'core/context/app.context';
import { PaymentStatus } from 'core/stores/payment/payment.store';
import { usePaymentContext } from 'payment/payment.context';
import styles from './payment.module.scss';

export const PaymentLoader = observer(({ children }: { children?: JSX.Element }) => {
  const { t } = useTranslation();
  const { ready, paymentStore } = useContext(AppContext);
  const { latestStatus, message: responseMessage, handlePaymentProcessing } = usePaymentContext();

  // Payment Return Handling
  useEffect(() => {
    if (!ready || !paymentStore?.pollingStore) {
      return;
    }

    handlePaymentProcessing();
  }, [ready, paymentStore?.pollingStore]);

  if (latestStatus !== PaymentStatus.Pending || !paymentStore?.pollingStore.isPolling) {
    return children;
  }

  const getText = () => {
    if (!responseMessage?.message) {
      return [t('loader.processingPayment'), t('loader.processingPayment')];
    }

    const { message } = responseMessage;
    return [message, message];
  };

  return (
    <div className={`${styles.outerWrapper}`}>
      <Panel backgroundType={PanelThemeType.Transparent} sizeType={PanelType.FullWidth} classes={['overlay-panel']}>
        <div className={`container ${styles.centerBox}`}>
          <div className="row justify-content-center">
            <div className="col-xl-5 col-lg-6 col-12">
              <Card backgroundType={CardThemeType.Light} centered>
                <WaitingLoader isLoading={true} texts={getText()} topOffset={true} />
              </Card>
            </div>
          </div>
        </div>
      </Panel>
    </div>
  );
});